import React, { lazy, Suspense, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import LoadingIndicator from 'components/LoadingIndicator';
import { addHttps } from 'utils/stringUtils';
const LazyHLSVideoPlayer = lazy(() => import('components/HLSVideoPlayer'));

export const m3u8Type = [
  'application/x-mpegURL',
  'application/vnd.apple.mpegurl',
  'application/x-mpegurl',
];

const defaultFormats = ['mp4', 'webm', 'ogg'];

const useStyles = makeStyles({
  root: {
    '& .video-js:not(.vjs-audio-only-mode)': {
      paddingTop: '56.25%',
    },
    '& video': {
      width: '100%',
      aspectRatio: '16/9',
    },
  },
});

export const PracticeVideo = ({ practice, ...rest }) => {
  const classes = useStyles();
  const videoRef = useRef(null);
  const contentType = practice.asset?.fields.file.contentType;
  const videoUrl =
    practice.videoUrl || addHttps(practice.asset.fields.file.url);

  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) {
      return undefined;
    }

    const listener = () => videoElement.play();
    videoElement.addEventListener('loadeddata', listener);
    return () => {
      videoElement.removeEventListener('loadeddata', listener);
    };
  }, []);

  const isDefaultFormat = defaultFormats.some(videoFormat =>
    videoUrl.endsWith(videoFormat),
  );

  return (
    <div className={classes.root}>
      <Suspense fallback={<LoadingIndicator />}>
        {isDefaultFormat ? (
          <video ref={videoRef} controls {...rest}>
            <source src={videoUrl} type={contentType}></source>
          </video>
        ) : (
          <LazyHLSVideoPlayer src={videoUrl} {...rest} />
        )}
      </Suspense>
    </div>
  );
};
